import script from "./product-grid-card.vue?vue&type=script&setup=true&lang=js"
export * from "./product-grid-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__